import moment from "moment"

export function confirmFunction(message, func, params) {
  confirm(message) && func(params);
}

export function random() {
  let random = Math.random(0, 100);

  return random;
}

export function translateTime(timestamp) {
  return moment(timestamp).format("YYYY-MM-DD HH:mm:ss");
}